/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */
import { Incoterms } from './incoterms';
import { BlankEnum } from './blankEnum';

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransportCostChoiceSelectionDTOSupplyIncoterm = { ...Incoterms, ...BlankEnum } as const;
